import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-medical-societies-page',
  standalone: true,
  imports: [CommonModule, RouterModule, MatIconModule, MatButtonModule],
  templateUrl: './medical-societies-page.component.html',
  styleUrl: './medical-societies-page.component.scss'
})
export class MedicalSocietiesPageComponent {
  features = [
    { icon: 'badge', title: 'Membership renewals', description: 'Automated dues renewal reminders on every plan keep members current with minimal staff effort.' },
    { icon: 'event', title: 'Annual meetings and CME events', description: 'Registration, agendas, abstracts, and credit tracking for conferences and education.' },
    { icon: 'person_search', title: 'Member directories', description: 'Searchable directories so members and staff find peers and collaborators quickly.' },
    { icon: 'groups', title: 'Board and committee communication', description: 'Keep leadership and committees aligned with dedicated spaces and workflows.' },
    { icon: 'payments', title: 'Dues and payments', description: 'Collect dues, track payments, and manage billing in one place.' },
    { icon: 'assessment', title: 'Reporting and admin workflows', description: 'Reports, exports, and workflows that support day-to-day society operations.' }
  ];

  examples = [
    'Northwest Society of Colon and Rectal Surgeons',
    'Society of Black Colon and Rectal Surgeons',
    'South Asian American Vascular Society',
    'Surgical Outcomes Club'
  ];
}
